const TYPES = new Set(['dialogue', 'action', 'shot', 'camera', 'audio', 'vfx', 'transition', 'environment']);

export function validateCues(payload, screenplay) {
  if (!payload || !Array.isArray(payload.cues)) {
    throw new Error('GlobalGPT returned JSON without a cues array.');
  }

  return payload.cues.map((cue, index) => {
    if (!TYPES.has(cue.type)) throw new Error(`Cue ${index + 1} has an unsupported type.`);
    if (typeof cue.selectedText !== 'string' || !screenplay.includes(cue.selectedText)) {
      throw new Error(`Cue ${index + 1} does not contain verbatim screenplay text.`);
    }
    if (!Number.isFinite(cue.startTime) || !Number.isFinite(cue.endTime) || cue.endTime < cue.startTime) {
      throw new Error(`Cue ${index + 1} has invalid timestamps.`);
    }
    return {
      type: cue.type,
      selectedText: cue.selectedText,
      startTime: cue.startTime,
      endTime: cue.endTime,
      speaker: cue.type === 'dialogue' ? (cue.speaker || null) : null,
      ...(cue.description ? { description: cue.description } : {})
    };
  });
}

export async function generateCues({ screenplay, frames, sessionToken }) {
  const response = await fetch('/api/generate-cues', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`
    },
    body: JSON.stringify({ screenplay, frames })
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || 'Cue generation failed.');
  return validateCues(body, screenplay);
}